var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExitHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25012 0.593408L14.7499 0.593408C14.9223 0.593624 15.0875 0.662181 15.2094 0.784045C15.3312 0.905922 15.3998 1.07116 15.4 1.24352V14.7433C15.3998 14.9157 15.3312 15.0809 15.2094 15.2028C15.0875 15.3246 14.9222 15.3932 14.7499 15.3934H1.25012C1.07776 15.3932 0.912513 15.3246 0.790636 15.2028C0.668759 15.0809 0.600201 14.9157 0.6 14.7433L0.6 9.59341H1.4V14.4934V14.5934H1.5H14.5H14.6V14.4934V1.49341V1.39341H14.5H1.5H1.4V1.49341V6.14341H0.6V1.24347C0.600215 1.07113 0.668772 0.905909 0.790636 0.784045C0.912513 0.662168 1.07776 0.593609 1.25012 0.593408Z",
    fill: "#9945EE",
    stroke: "#9945EE",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54288 8.24665H0.6V7.44665H9.54294H9.78436L9.61365 7.27594L6.68445 4.34671L7.25012 3.78107L11.3157 7.84662L7.25013 11.9122L6.68445 11.3465L9.61359 8.41736L9.7843 8.24665H9.54288Z",
    fill: "#9945EE",
    stroke: "#9945EE",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExitHover);
export default __webpack_public_path__ + "static/media/icon-exit-hover.7bada1bd24d2cbdd649b83f8985ba8ff.svg";
export { ForwardRef as ReactComponent };